import { useCallback, useState } from 'react'
import type { ConditionTree } from '@kc3/conversations'
import { api } from '../api/client.js'

export interface EvaluateResult {
  matches: boolean
  actions: unknown[]
}

export interface UseEvaluateRuleReturn {
  evaluate: (
    rule: { conditions: ConditionTree; actions: unknown[] },
    context: Record<string, unknown>,
  ) => Promise<EvaluateResult>
  isPending: boolean
}

/**
 * Test-harness hook for RuleBuilder's "test against sample" sidebar.
 * POSTs /admin/conversations/rules/evaluate and returns whether the
 * rule matched plus the actions that would fire.
 */
export function useEvaluateRule(): UseEvaluateRuleReturn {
  const [isPending, setIsPending] = useState(false)

  const evaluate = useCallback(
    async (
      rule: { conditions: ConditionTree; actions: unknown[] },
      context: Record<string, unknown>,
    ): Promise<EvaluateResult> => {
      setIsPending(true)
      try {
        return await api.post<EvaluateResult>(
          '/admin/conversations/rules/evaluate',
          { rule, context },
        )
      } finally {
        setIsPending(false)
      }
    },
    [],
  )

  return { evaluate, isPending }
}
